// src/components/Typewriter.jsx
import React, { useState, useEffect, useRef } from "react";

const Typewriter = ({ text, speed = 50, delay = 0, className = "", start = false }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [cursorVisible, setCursorVisible] = useState(true);
  const hiddenRef = useRef(null);
  const [minHeight, setMinHeight] = useState(0);

  // Blink the cursor.
  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setCursorVisible((prev) => !prev);
    }, 530);
    return () => clearInterval(blinkInterval);
  }, []);

  // Measure the height of the final text once rendered in a hidden span.
  useEffect(() => {
    if (hiddenRef.current) {
      setMinHeight(hiddenRef.current.offsetHeight);
    }
  }, [text]);

  // Animate the text if start is true.
  useEffect(() => {
    if (!start) {
      setDisplayedText("");
      return;
    }
    let animationFrame;
    let startTime = null;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime - delay;
      if (elapsed < 0) {
        animationFrame = requestAnimationFrame(animate);
        return;
      }
      const totalDuration = text.length * speed;
      if (elapsed >= totalDuration) {
        setDisplayedText(text);
        return;
      }
      const targetIndex = Math.floor(elapsed / speed);
      setDisplayedText(text.slice(0, targetIndex + 1));
      animationFrame = requestAnimationFrame(animate);
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [text, speed, delay, start]);

  return (
    <span
      className={className}
      style={{ minHeight: minHeight || "auto", position: "relative", display: "inline-block" }}
    >
      {displayedText}
      <span
        className="inline-block w-[2px] h-[1em] ml-1 -mb-[0.2em] bg-current"
        style={{ opacity: cursorVisible ? 1 : 0 }}
      />
      {/* Hidden element used to measure the final height */}
      <span
        ref={hiddenRef}
        style={{
          visibility: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          pointerEvents: "none",
          whiteSpace: "pre-wrap",
        }}
      >
        {text}
      </span>
    </span>
  );
};

export default Typewriter;
